"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var IntegrationsListUI_1 = __importDefault(require("./IntegrationsListUI"));
var IntegrationsListController = (function () {
    function IntegrationsListController(di, user, integrationService, rolesService) {
        this.allIntegrations = integrationService.getIntegrations();
        this.allCategories = integrationService.getIntegrationCategories();
        this.integrationService = integrationService;
        this.ui = di.convoke(IntegrationsListUI_1.default, null, {
            controller: this,
            isAdmin: rolesService.isAdmin(user),
        });
        this.usingFreshBooks = integrationService.isEnabled("freshbooks");
    }
    IntegrationsListController.prototype.getIntegrations = function (search, split, list) {
        var _this = this;
        var integrationsList = list || this.allIntegrations;
        if (!!search) {
            integrationsList = lodash_1.default.filter(integrationsList, function (integration) {
                return lodash_1.default.includes(integration.name.toLowerCase(), search.toLowerCase());
            });
        }
        integrationsList = lodash_1.default.filter(integrationsList, function (_a) {
            var internalName = _a.internalName;
            if (internalName === "freshbooks") {
                return _this.usingFreshBooks;
            }
            else {
                return true;
            }
        });
        if (split) {
            if (split.takeFirst) {
                integrationsList = integrationsList.slice(0, split.takeFirst);
            }
            else if (split.skipFirst) {
                integrationsList = integrationsList.slice(split.skipFirst);
            }
        }
        return integrationsList;
    };
    IntegrationsListController.prototype.getIntegrationsInCategory = function (category, search) {
        var rawIntegrationsList = this.integrationService.getIntegrationsInCategory(category);
        return this.getIntegrations(search, undefined, rawIntegrationsList);
    };
    IntegrationsListController.prototype.getSpecificIntegrations = function (integrations) {
        var integrationsList = lodash_1.default.filter(this.allIntegrations, function (integration) {
            return lodash_1.default.includes(integrations, integration.internalName);
        });
        return integrationsList;
    };
    IntegrationsListController.prototype.getIntegrationCategories = function () {
        return this.allCategories;
    };
    return IntegrationsListController;
}());
exports.default = IntegrationsListController;
